import src from "IMAGE";
export default { src, width: 807, height: 263, blurWidth: 0, blurHeight: 0};
